/**
 * Shared pick-lists for grades and remarks.
 *
 * Both are dropdown-only by design — free text is not accepted, so the values
 * stay consistent across exams, progress cards and any reporting built on them.
 * Note the consequence: a remark or grade saved before this change that is not
 * in these lists will render as empty rather than showing the old free text.
 */

/** Grade scale, in the order the school uses it. */
export const GRADE_OPTIONS = [
  "A",
  "A+",
  "B",
  "B+",
  "C",
  "C+",
  "D",
  "D+",
  "E",
  "E+",
  "F",
];

/** Remark ladder, best first. Shared by exams and progress cards. */
export const REMARK_OPTIONS = [
  "Excellent",
  "Very Good",
  "Good",
  "Satisfactory",
  "Needs Improvement",
  "Must Put In More Effort",
];
